module.exports = __webpack_public_path__ + "static/media/31-6.debeeb99.mp3";